import { useQuery } from "@tanstack/react-query";
import { http } from "../../../../../../services/HttpService";
import { QUERY_KEYS, HTTP_ENDPOINTS } from "../../../../../../consts/api";

export const useMembershipSalesV2 = (params, options = {}) => {
  return useQuery(
    [QUERY_KEYS.membershipSalesV2, params],
    async () => {
      const res = await http.get(HTTP_ENDPOINTS.getBiMembershipSalesV2(), {
        params,
      });

      const composeResponse = {
        clinics: Object.values(res.data.data.filters.clinics || {}),
        clinicMembershipSales: res.data.data.report.clinic_report,
        providerMembershipSales: res.data.data.report.provider_report,
      };
      return composeResponse;
    },
    options,
  );
};
